import styled from "styled-components";
import IconSmallWarn from "../../assets/ic-smallWarn.svg";
import MyTypography from "../Typography";
import Space from "../Space";

const WarnText = ({ label }) => {
  return (
    <Container>
      <img src={IconSmallWarn} style={{ marginTop: 2 }} />
      <Space width="10px" />
      <MyTypography>{label}</MyTypography>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 10px 0px;
`;

export default WarnText;
